import React, {useContext, useEffect} from 'react';
import {ContextOperacion, ContextOperacionType} from "../../RefactorLayout";
import {useOperacionCapitalMarkets} from "./hooks/useOperacionCapitalMarkets";
import {EntityWithIdFields, QueryStatus} from "../../../../types";
import {useLoader} from "../../../../hooks/useLoader";
import {Alert, Grid} from "@mui/material";
import {FormOperacionCapitalMarkets, OperacionCapitalMarkets, schemaFormOperacionCapitalMarkets} from "./types/types";
import {SubmitHandler, useForm} from "react-hook-form";
import {schemaFormOperacionContraparte} from "../contraparte/types/types";
import {zodResolver} from "@hookform/resolvers/zod";
import toast from "react-hot-toast";
import {HttpCapitalMarkets} from "./api/httpCapitalMarkets";
import {SeccionContraparteDatosOperacion} from "../contraparte/components";
import SeccionCapitalMarketsDatosOperacion from "./components/SeccionCapitalMarketsDatosOperacion";
import {SeccionFirmas} from "../../components/SeccionFirmas";
import {OperacionCapitalMarketsViewDTO} from "./types/dto";
import SeccionCapitalMarketsDetalle from "./components/SeccionCapitalMarketsDetalle";
import {SistemaTipo} from "../../../../types/enum/enum";

interface SistemaCapitalMarketsContentProps {
  operacion: OperacionCapitalMarketsViewDTO
}

const SistemaCapitalMarketsContent = ({operacion}: SistemaCapitalMarketsContentProps) => {
  const {setSavePromise, permisoTipo} = useContext<ContextOperacionType>(ContextOperacion)

  const formMethods = useForm<FormOperacionCapitalMarkets>({
    resolver: zodResolver(schemaFormOperacionCapitalMarkets),
    values: {...operacion}
  })

  const {showLoader, hideLoader} = useLoader()

  useEffect(() => {
    if (operacion.permiteEditarOperacion) {
      const handleSave: SubmitHandler<FormOperacionCapitalMarkets> = (data) => {
        showLoader()
        const promise = HttpCapitalMarkets.put(operacion[EntityWithIdFields.Id], data)

        toast.promise(promise, {
          loading: 'Guardando.',
          success: 'Guardado correctamente.',
          error: e => `${e}`
        }).finally(hideLoader)
      }

      const onSave = () => formMethods.handleSubmit(handleSave)
      setSavePromise(onSave)
    }
  }, [])

  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <SeccionCapitalMarketsDatosOperacion
            formMethods={formMethods}
            readOnly={!operacion.permiteEditarOperacion}
            operacion={operacion}
            codSistemaPrincipal={operacion.codPais}
          />
        </Grid>
        <Grid item xs={12}>
          <SeccionCapitalMarketsDetalle
            codPais={operacion.codPais}
            operacionId={operacion.id}
            permiteEditar={operacion.permiteEditarOperacion}
          />
        </Grid>
        <Grid item xs={12}>
          <SeccionFirmas
            codSistema={SistemaTipo.CapitalMarkets}
            idOperacion={operacion[EntityWithIdFields.Id]}
          />
        </Grid>
      </Grid>
    </>
  )
}

function SistemaCapitalMarkets() {
  const {idOperacion} = useContext<ContextOperacionType>(ContextOperacion)

  const {status, operacion} = useOperacionCapitalMarkets(idOperacion)

  const {showLoader, hideLoader} = useLoader()


  useEffect(() => {
    if (status === QueryStatus.Loading) {
      showLoader()
    } else {
      hideLoader();
    }
  }, [status])

  if (!operacion) {
    return (
      <></>
    )
  }

  if (status === QueryStatus.Error) {
    return (
      <Alert severity='error'>
        Se produjo un error al cargar la operación.
      </Alert>
    )
  }

  return (
    <SistemaCapitalMarketsContent
      operacion={operacion}
      />
  );
}

export default SistemaCapitalMarkets;